import Vue from 'vue';
// import {
//   MenuItem
// } from '../objects/FeaturesSetting.js';
import MenuItem from '@/objects/model/MenuItem.js';

const featureModule = {
  state: {
    enabledFeatures: new MenuItem(),
    currentPrimary: '',
    currentSecondary: '',
    currentTertiary: '',
    currentTitle: '',
    openSencondaries: []
  },
  getters: {
    Title: (state) => state.currentTitle || '',
    primaryFeatures: (state) => {
      const features = state.enabledFeatures.children || [];
      return features.map((item) => {
        const newItem = item.Clone();
        if (newItem.id === state.currentPrimary) {
          newItem.current = true;
        } else {
          newItem.current = false;
        }
        return newItem;
      });
    },
    getSecondaryFeatures: (state, getters) => (id) => {
      const features = (getters.primaryFeatures.filter((item) => item.id === id)[0] || {}).children || [];
      return features.map((item) => {
        const newItem = item.Clone();
        if (newItem.primary === state.currentPrimary && newItem.id === state.currentSecondary) {
          newItem.current = true;
        } else {
          newItem.current = false;
        }
        newItem.open = state.openSencondaries.indexOf(newItem.id) !== -1;
        return newItem;
      });
    },
    getTertiaryFeatures: (state, getters) => {
      const features = (getters.getSecondaryFeatures(state.currentPrimary).filter((item) => item.id === state.currentSecondary)[0] || {}).children || [];
      return features.map((item) => {
        const newItem = item.Clone();
        if (newItem.primary === state.currentPrimary && newItem.secondary === state.currentSecondary && newItem.id === state.currentTertiary) {
          newItem.current = true;
        } else {
          newItem.current = false;
        }
        return newItem;
      });
    },
    /**
     * 取得點選到Menu的第三層
     * @param {string} primaryId  第一層的Menu的Id
     * @param {string} secondaryId 第二層的Menu的Id
     * @returns
     */
    getSelectedTeriaryFeatures: (state, getters) => (primaryId, secondaryId) => {
      const features = (getters.getSecondaryFeatures(primaryId).filter((item) => item.id === secondaryId)[0] || {}).children || [];
      return features.map((item) => {
        const newItem = item.Clone();
        if (newItem.primary === state.currentPrimary && newItem.secondary === state.currentSecondary && newItem.id === state.currentTertiary) {
          newItem.current = true;
        } else {
          newItem.current = false;
        }
        return newItem;
      });
    },
    currentFeature: (state, getters) => {
      if (state.currentTertiary !== '') {
        return getters.getTertiaryFeatures.filter((v) => v.current)[0];
      }

      if (state.currentSecondary !== '') {
        return getters.getSecondaryFeatures(state.currentPrimary).filter((v) => v.current)[0];
      }

      if (state.currentPrimary !== '') {
        return getters.primaryFeatures.filter((v) => v.current)[0];
      }
      return null;
    }
  },
  mutations: {
    setFeatures(state, features) {
      Vue.set(state, 'enabledFeatures', features || new MenuItem());
    },
    setNavigation(state, payload) {
      Vue.set(state, 'currentPrimary', payload.primary || '');
      Vue.set(state, 'currentSecondary', payload.secondary || '');
      Vue.set(state, 'currentTertiary', payload.tertiary || '');
      Vue.set(state, 'currentTitle', payload.title || '');
    },
    setSecondaryOpen(state, payload) {
      if (payload.open) {
        state.openSencondaries.push(payload.id);
      } else {
        const index = state.openSencondaries.indexOf(payload.id);
        state.openSencondaries.splice(index, 1);
      }
    }
  }
};

export default {
  module: featureModule
};
